module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/NGXCalculator-b3de860890cb4d8e7c2e98f20ef7a7ea.png";